import React, { useState } from 'react';
import { GraduationCap, Code } from 'lucide-react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

const AuthScreen: React.FC = () => {
    const [isLogin, setIsLogin] = useState(true);

    const toggleMode = () => {
        setIsLogin(!isLogin);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">

                {/* Auth Form */}
                <div className="bg-white rounded-xl shadow-lg p-8">
                    {isLogin ? <LoginForm onToggleMode={toggleMode} /> : <SignupForm onToggleMode={toggleMode} />}
                </div>

                {/* Footer */}
                <div className="text-center mt-8 text-sm text-gray-500">
                    <div className="flex items-center justify-center mb-2">
                        <Code className="h-4 w-4 text-emerald-500 mr-2" />
                        <span>Developed by</span>
                    </div>
                    <p className="font-semibold text-emerald-600">MIS Providers</p>
                    <p className="text-xs mt-1">&copy;Dynamix Zone. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default AuthScreen;
